import React from "react";
import styled from "styled-components";
import img1 from "../images/ceo1.jpeg";
import img2 from "../images/mket1.jpeg";
import img3 from "../images/mket2.jpeg";

import bkgroundimg from "../images/abus.jpg";
function AboutUs() {
  return (
    <AboutUsCon>
      <div className="bkgpic_msg">
        <div className="message">About Futurebreakgh</div>
      </div>
      <a className="globalhome" href="/">
        Global Home{" "}
      </a>
      | About Futurebreakgh
      <div className="imgandesc">
        <div className="image-container">
          <img className="image" src={img1} alt=" " />
        </div>
        <div className="desc-container">
          As the CEO of Futurebreakgh Freight Services, it is my privilege to
          welcome you to our esteemed network of clients, partners, and team
          members who are dedicated to revolutionizing the logistics industry.
          Transportation is the lifeblood of international trade, connecting
          markets and communities across the globe. At Global Transport
          Solutions, we are honored to be a vital part of this dynamic process,
          ensuring that your cargo reaches its destination safely, promptly, and
          in impeccable condition. Our mission extends beyond mere
          transportation; it is about fostering trust, reliability, and
          excellence in every transaction. Our unwavering commitment to
          innovation, eco-friendly practices, and a customer-centric approach
          enables us to address the changing demands of our clients and
          partners, wherever they may be. Thank you for entrusting Global
          Transport Solutions. We eagerly anticipate supporting your endeavors,
          as we move not only goods but also prosperity, across borders and
          beyond. Let us work together to drive the world forward.cess, across
          borders and beyond. Together, let’s move the world.
        </div>

        <div className="desc-container">
          We are dedicated to providing efficient, dependable, and customized
          logistics solutions that cater to the evolving needs of your business.
          Our team of seasoned experts is committed to ensuring the safe,
          timely, and compliant transportation of your goods, adhering to all
          international standards. Whether your shipments are local or global,
          our extensive range of services—including ocean freight, air cargo,
          customs clearance, and door-to-door delivery—guarantees a smooth and
          optimized supply chain. At Integral Freight Services, we cherish the
          partnerships we've cultivated with our clients and constantly aim to
          surpass your expectations. Our mission is to support your business by
          offering solutions that foster your success. Thank you for choosing us
          for your logistics requirements. We eagerly anticipate the opportunity
          to serve you and to be a trusted partner in your global trade
          endeavors.
        </div>
        <div className="image-container">
          <img className="image" src={img2} alt=" " />
        </div>
        <div className="image-container">
          <img className="image" src={img3} alt=" " />
        </div>
        <div className="desc-container">
          We take immense pride in our unwavering dedication to excellence,
          guaranteeing that your shipments receive the highest level of care and
          are delivered punctually. Our team of seasoned professionals works
          diligently to simplify logistics, optimize transportation routes, and
          provide tailored services that distinguish us in the industry. We
          recognize the critical value of your cargo and aim to surpass your
          expectations with every delivery. Thank you for selecting Noble
          Shipping as your reliable freight forwarding partner. We eagerly
          anticipate continuing our successful partnership and reaching new
          milestones in service excellence together.
        </div>
      </div>
    </AboutUsCon>
  );
}

export default AboutUs;

const AboutUsCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .bkgpic_msg {
    background-image: url(${bkgroundimg});
    background-repeat: no-repeat;
    background-position: center; /* Center the background image */
    background-size: cover; /* Ensure the image covers the entire div */
    height: 30vh;
    display: flex; /* Use flexbox to center the text inside */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: relative; /* Allow positioning of text elements over the image */
  }

  .message {
    font-weight: bold;

    font-size: 50px;
  }
  .globalhome {
    padding-bottom: 20px;
  }

  .imgandesc {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin-top: 50px;
    gap: 30px;
  }
  .image-container .image {
    width: 20vw;
    height: 40vh;
    border-radius: 50%;
    border: 2px solid gainsboro;
    align-items: center;.
       justify-content: center;

  }

  .imgandesc .desc-container {
    padding: 20px;

    text-align: justify;
  }

  @media (max-width: 700px) {
    width: 100vw;

    .imgandesc {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      margin-top: 50px;
      gap: 30px;
      margin-left: -85px;
      padding-left: 5px;
      padding-right: 15px;
    }
    .image-container .image {
      width: 100vw;
      height: 30vh;
      justify-content: center;
      align-items: center;
      border-radius: 0px 200px 200px 0px;
    }
    .desc-containe {
      width: 100%;
    }
    .bkgpic_msg {
      margin-left: -65px;
    }
  }
`;
